import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "text"]

  connect() {
    this.element.addEventListener('loading-overlay:show', this.showWithMessage.bind(this))
    this.element.addEventListener('loading-overlay:hide', this.hide.bind(this))
    this.overlayTarget.style.display = "none"
  }

  disconnect() {
    this.element.removeEventListener('loading-overlay:show', this.showWithMessage.bind(this))
    this.element.removeEventListener('loading-overlay:hide', this.hide.bind(this))
  }

  show() {
    this.overlayTarget.style.display = "flex"
    this.overlayTarget.classList.add('active')
  }

  showWithMessage(event) {
    this.show()
    if (event.detail && event.detail.message && this.hasTextTarget) {
      this.textTarget.textContent = event.detail.message
    }
  }

  hide() {
    this.overlayTarget.style.display = "none"
    this.overlayTarget.classList.remove('active')
    if (this.hasTextTarget && this.textTarget.dataset.defaultMessage) {
      this.textTarget.textContent = this.textTarget.dataset.defaultMessage
    }
  }
} 